import { render, staticRenderFns } from "./UpdateCalendar.vue?vue&type=template&id=85a8a766"
import script from "./UpdateCalendar.vue?vue&type=script&lang=js"
export * from "./UpdateCalendar.vue?vue&type=script&lang=js"
import style0 from "./UpdateCalendar.vue?vue&type=style&index=0&id=85a8a766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports